export default "__VITE_ASSET__DlfDIebd__"